import { createRouter, type RouterHistory } from '@tanstack/react-router'

import { LoadingNotice } from '@/ui/loading-notice'

import { AreaNotFound, rootRoute } from './routes/root'
import { appRoute } from './routes/app-route'
import { entityRoute } from './routes/entity-route'
import { PageErrorFallback } from './error-boundary'
import { composeRouteTree, moduleRoutes } from './module-registry'

const routes = [appRoute, entityRoute, ...moduleRoutes()]

export const routeTree = composeRouteTree(rootRoute, routes) as ReturnType<
  typeof rootRoute.addChildren<typeof routes>
>

export function buildRouter(
  context: { isAuthenticated: boolean },
  history?: RouterHistory,
) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
    defaultErrorComponent: PageErrorFallback,
    defaultNotFoundComponent: AreaNotFound,
    defaultPendingComponent: () => <LoadingNotice message="Loading…" />,
    ...(history ? { history } : {}),
  })
}

// Overridden by <RouterProvider context={...} /> in App.tsx on auth changes.
export const router = buildRouter({ isAuthenticated: false })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
